import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, UntypedFormControl } from "@angular/forms";
import { isEmpty } from "lodash";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { CONSTANT } from "src/app/constant";
import { CandidateRole } from "src/app/models/enum";
import {
	DraftItem,
	InstructorOtherComments,
	InstructorOtherCommentsReg,
	OBComments,
	OBCommentsReq,
} from "src/app/models/models";
import { DraftService } from "../../services/draft.service";
import { HttpService } from "../../services/http.service";
import { SharedService } from "../../services/shared.service";

@Component({
	selector: "app-cbta-view-summary-modal",
	templateUrl: "./cbta-view-summary-modal.component.html",
	styleUrls: ["./cbta-view-summary-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CbtaViewSummaryModalComponent implements OnInit {
	@Input() comments: OBComments[] = [];
	@Input() instructorComments: InstructorOtherComments[] = [];
	@Input() traineeAssessmentId: string = "";
	CANDIDATE_ROLE = CONSTANT.CANDIDATE_ROLE;
	editable: Array<boolean> = [];
	addObComments = new UntypedFormControl("");
	otherInstructorComments = new UntypedFormControl("");
	PFPMToggleForm!: FormGroup;

	constructor(
		private httpService: HttpService,
		private draftService: DraftService,
		private sharedService: SharedService,
		private dbService: NgxIndexedDBService,
		private fb: FormBuilder,
	) {}

	ngOnInit(): void {
		this.resetEditable();
		this.createPFPMToggleForm();
	}

	createPFPMToggleForm(): void {
		this.PFPMToggleForm = new FormGroup({
			PFPMToggles: this.fb.array([]),
		});

		this.updatePFPMToggles();
	}

	updatePFPMToggles(): void {
		this.comments.forEach((item, index) => {
			this.addPFPMToggle(index, item.candidateRole !== CONSTANT.CANDIDATE_ROLE.PF);
		});
	}

	addPFPMToggle(id: number, initialValue: boolean): void {
		this.toggleArray.push(
			this.fb.group({
				id: id,
				value: initialValue,
			}),
		);
	}

	getToggleControl(idx: number): FormGroup | null {
		const toggles = this.toggleArray.controls as FormGroup[];
		const toggleControl = toggles.find((toggle) => toggle.get("id")?.value === idx);
		return toggleControl || null;
	}

	getToggleValue(id: number): boolean {
		const control = this.getToggleControl(id);
		return control ? control.get("value")?.value : false;
	}

	get toggleArray(): FormArray {
		return this.PFPMToggleForm.get("PFPMToggles") as FormArray;
	}

	onToggleChange(id: number, isChecked: boolean): void {
		const control = this.getToggleControl(id);
		// const role = value !== CONSTANT.CANDIDATE_ROLE.PF;
		if (control) {
			control.get("value")?.setValue(isChecked);
		}
	}

	editComment(comment: OBComments, index: number): void {
		console.log("edit comment", comment);
		//remove previous open comments to non editable
		this.resetEditable();
		//open comments
		this.editable[index] = true;
		this.addObComments.setValue(comment.instructorComment);
		console.log(comment.commentId);
	}

	saveComment(comment: OBComments, index: number): void {
		if (!navigator.onLine || this.inDraftMode) {
			this.dbService.getByID<DraftItem>(CONSTANT.INDEXEDDB.DRAFT, this.traineeAssessmentId).subscribe(
				(record) => {
					this.setEditedOBComments("offline", comment, index, record);
				},
				(error) => {
					console.error(error);
				},
			);
		} else {
			const role = this.getToggleValue(index) === true ? CandidateRole.PM : CandidateRole.PF;
			if (comment.commentId) {
				// OB comments update
				this.httpService
					.updateOBComment(comment.commentId, {
						description: this.addObComments.value,
						candidateRole: role,
					})
					.subscribe((resp: any) => {
						this.editable[index] = false;
						comment.instructorComment = this.addObComments.value;
						comment.candidateRole = role;

						// to do add obAction on tempdraft
						this.setEditedOBComments("online", comment, index, this.draftService.tempDraft);
					});
			} else {
				// console.error('comment ID is missing.');

				// no comment ID for 'TEM' but must have candidateId
				if (comment?.ob === "TEM" && comment.candidateId) {
					// TEM comment update
					this.httpService
						.updateTEMComment(comment.candidateId, comment.maneuverCode, {
							remakrs: this.addObComments.value,
							candidateRole: role,
						})
						.subscribe((resp: any) => {
							console.log("TEM comment updated", resp);
							this.editable[index] = false;
							comment.instructorComment = this.addObComments.value;
							comment.candidateRole = role;

							// to do add obAction on tempdraft
							this.setEditedOBComments("online", comment, index, this.draftService.tempDraft);
						});
				} else {
					console.error("candidate ID is missing.");
				}
			}
		}
	}

	setEditedOBComments(state: string, comment: OBComments, index: number, record: any): void {
		const candidateRating = record?.candidateRating ?? {};

		const addRemoveOb = candidateRating?.addRemoveOb ?? [];
		const selectedOBs = candidateRating?.selectedOBs ?? [];

		const role = this.getToggleValue(index) === true ? CandidateRole.PM : CandidateRole.PF;

		if (comment?.ob !== "TEM") {
			selectedOBs.map((item: OBComments, commeintIdx: number) => {
				if (
					item.maneuver == comment.maneuver &&
					item.ob == comment.ob &&
					item.candidateId == comment.candidateId &&
					item.commentId == comment.commentId
				) {
					item.instructorComment = this.addObComments.value;
					this.comments[index].instructorComment = this.addObComments.value;
					this.comments[index].candidateRole = role;
					selectedOBs[index].candidateRole = role;
				}
			});
		}
		if (comment?.ob === "TEM") {
			selectedOBs.map((item: OBComments, commeintIdx: number) => {
				if (item.maneuver == comment.maneuver && item.ob == comment.ob && item.candidateId == comment.candidateId) {
					item.instructorComment = this.addObComments.value;
					this.comments[index].instructorComment = this.addObComments.value;
					this.comments[index].candidateRole = role;
					selectedOBs[index].candidateRole = role;
				}
			});
		}

		addRemoveOb.map((item: OBCommentsReq, commeintIdx: number) => {
			if (
				item.maneuverCode == comment.maneuverCode &&
				item.candidateId == comment.candidateId &&
				item.observationCode == comment.observationCode
				// commeintIdx == index
			) {
				item.description = this.addObComments.value;
				item.candidateRole = role;
			}
		});
		if (state === "online") {
			this.draftService.tempDraft = {
				candidateRating: {
					...candidateRating,
					addRemoveOb,
					selectedOBs,
				},
			};
			console.log("draft updated", this.draftService.tempDraft);
		} else if (state === "offline") {
			this.dbService
				.update(CONSTANT.INDEXEDDB.DRAFT, {
					...record,
					candidateRating: {
						...candidateRating,
						selectedOBs,
						addRemoveOb,
					},
					lastUpdatedDate: new Date().toISOString(),
					continuePage: 2,
				})
				.subscribe(
					(result) => {
						console.log("comments updated", result);

						this.editable[index] = false;

						// this.sharedService.setOBComments(selectedOBs);
					},
					(error) => {
						console.error(error);
					},
				);
		}
		// update UI to set on/off toggle
		this.updatePFPMToggles();
	}

	editInstructorComment(comment: InstructorOtherComments, index: number): void {
		//remove previous open comments to non editable
		this.resetInstructorEditable();
		//open comments
		this.editable[index] = true;
		this.otherInstructorComments.setValue(comment.comment);
	}

	saveInstructorComment(comment: InstructorOtherComments, index: number): void {
		if (!navigator.onLine || this.inDraftMode) {
			this.dbService.getByID<DraftItem>(CONSTANT.INDEXEDDB.DRAFT, this.traineeAssessmentId).subscribe(
				(record) => {
					this.setEditedOtherComments("offline", comment, index, record);
				},
				(error) => {
					console.error(error);
				},
			);
		} else {
			if (comment.maneuverCode) {
				const data = {
					candidateId: comment.candidateId,
					maneuverCode: comment.maneuverCode,
					comment: this.otherInstructorComments.value,
				} as InstructorOtherCommentsReg;
				this.httpService.instructorOtherComments(data).subscribe((resp: any) => {
					this.editable[index] = false;
					comment.comment = this.otherInstructorComments.value;

					//for offline data
					this.setEditedOtherComments("online", comment, index, this.draftService.tempDraft);
				});
			} else {
				console.error("maneuver ID is missing.");
			}
		}
	}

	setEditedOtherComments(state: string, comment: InstructorOtherComments, index: number, record: any): void {
		const candidateRating = record?.candidateRating ?? {};

		let otherComments = candidateRating?.otherComments ?? [];

		otherComments.map((item: InstructorOtherCommentsReg, commeintIdx: number) => {
			if (item.candidateId === comment.candidateId && item.maneuverCode === comment.maneuverCode) {
				comment.comment = this.otherInstructorComments.value;
				item.comment = this.otherInstructorComments.value;

				//TODO: if 2 or more comment for same maneuverCode, then it overwrites all comments with same updated comment
			}
		});

		if (state === "online") {
			this.draftService.tempDraft = {
				candidateRating: {
					...candidateRating,
					otherComments,
				},
			};
			console.log("draft updated", this.draftService.tempDraft);
		} else if (state === "offline") {
			console.log("otherComments", otherComments);
			this.dbService
				.update(CONSTANT.INDEXEDDB.DRAFT, {
					...record,
					candidateRating: {
						...candidateRating,
						otherComments,
					},
					lastUpdatedDate: new Date().toISOString(),
					continuePage: 2,
				})
				.subscribe(
					(result) => {
						this.editable[index] = false;
						// this.otherTrainingComments.push(uidata);
						// this.sharedService.setOtherTrainingComments(
						//   this.instructorComments
						// );
					},
					(error) => {
						console.error(error);
					},
				);
		}
	}

	resetEditable(): void {
		this.editable = Array(this.comments.length).fill(false);
	}

	resetInstructorEditable(): void {
		this.editable = Array(this.instructorComments.length).fill(false);
	}

	isCommentEmpty(): boolean {
		return isEmpty(this.addObComments.value.replace(/\s/g, "")) ? true : false;
	}

	get inDraftMode(): boolean {
		return this.draftService.inDraftMode;
	}
}
